import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection, unwrapVoid } from '../../ruutsApi/normalize'

function featuresToEntities({ farmId, exclusionTypes, features }) {
  return features.map(exclusion => ({
    id: exclusion.properties?.id,
    name: exclusionTypes.find(
      exclusionType => exclusionType.id === exclusion.properties.exclusionAreaTypeId,
    ).es_AR,
    otherName: exclusion.properties.otherName,
    exclusionAreaTypeId: exclusion.properties.exclusionAreaTypeId,
    hasGrazingManagement: exclusion.properties.hasGrazingManagement,
    geometry: exclusion.geometry,
    farmId,
  }))
}

export const createExclusionAreasFeatureByFarm = async ({ farmId, features, exclusionTypes }) => {
  if (!features?.length) return []

  const featuresToCreate = featuresToEntities({ farmId, features, exclusionTypes })
  const response = await apiClient.post(endpoints.exclusionAreas, featuresToCreate)
  return unwrapCollection(response)
}

// PUT /v1/exclusionAreas answers a message-only envelope (no payload): unwrapping a
// payload here would throw after the server already committed the write. Consumers
// refresh via invalidateQueries, never by seeding the cache with this response.
export const updateExclusionAreasFeatureByFarm = async ({ farmId, features, exclusionTypes }) => {
  if (!features?.length) return undefined

  const featuresToUpdate = featuresToEntities({ farmId, features, exclusionTypes })
  const response = await apiClient.put(endpoints.exclusionAreas, featuresToUpdate)
  return unwrapVoid(response)
}
